import React from 'react'
// Context
import { usePrismic } from '../../context/PrismicContext'
import { useAuthContext } from '../../context/AuthContext'
import { useCartContext } from '../../context/CartContext'
// Styles
import { Wrapper, Container, DiscountText } from './OrderDetails.styles'
// Utils
import { getOrderDetailValues } from '../../utils/cartHelpers'

const OrderDetails = ({
  prices,
  shipping,
  showShippingAndTax,
  showWholesaleTotal,
  total_item_count,
  total_quantity,
  wholesale_total,
  shippingTotal,
  taxValue,
  totalPV,
}) => {
  const {
    localeCountryCode,
    prismicData: {
      prismicCartPage: {
        discount: discountText,
        items,
        shipping: shippingPrismicText,
        sub_total,
        tax,
        total,
        handling,
        handling_price,
      },
    },
  } = usePrismic()

  const { userType } = useAuthContext()
  const { isAmbOfferInCart } = useCartContext()

  const { getAmounts, getTotalWithShipping } = getOrderDetailValues({
    ...prices,
    shipping,
  })
  const { subTotalText, taxesText, shippingText } = getAmounts()

  const showDiscount = () => {
    if (!prices?.discounts) return null

    return prices?.discounts?.map((discount, i) => {
      const discountLabel = discount?.label ?? discountText[0].text
      const discountValue = `-$${discount?.amount?.value?.toFixed(2) ?? ''}`
      return (
        <Container key={`${discount.label}-${i}`}>
          <DiscountText>{discountLabel}</DiscountText>
          <DiscountText>{discountValue}</DiscountText>
        </Container>
      )
    })
  }

  const showTotal = total_item_count ? total_item_count : total_quantity
  // make sure shipping and handling doesn't show negative - don't subtract if there is no shipping cost
  const shippingMinusHandling =
    shippingText > handling_price && handling_price
      ? (shippingText - handling_price).toFixed(2)
      : shippingText
  const handlingPrice = shippingTotal > handling_price ? handling_price : 0

  return (
    <Wrapper>
      <Container>
        <span data-qa="subTotalText">{`${sub_total[0].text} (${showTotal} ${items[0].text})`}</span>
        <span data-qa="subTotal">
          ${showWholesaleTotal ? wholesale_total.toFixed(2) : subTotalText}
        </span>
      </Container>
      {showDiscount()}
      {showShippingAndTax ? (
        <>
          {localeCountryCode === 'us' && (
            <Container>
              <span data-qa="taxText">{tax[0].text}</span>
              <span data-qa="tax">${taxesText}</span>
            </Container>
          )}
          <Container>
            <span data-qa="shippingText">{shippingPrismicText[0].text}</span>
            <span data-qa="shipping">{`$${shippingMinusHandling}`}</span>
          </Container>
          {handling_price > 0 && (
            <Container>
              <span data-qa="handlingText">{handling[0].text}</span>
              <span data-qa="handling">{`$${handlingPrice.toFixed(2)}`}</span>
            </Container>
          )}
        </>
      ) : null}
      <Container total>
        <span data-qa="totalText">{total[0].text}</span>
        <span data-qa="total">
          $
          {showWholesaleTotal
            ? (wholesale_total + taxValue + shippingTotal).toFixed(2)
            : getTotalWithShipping()}
        </span>
      </Container>
      {userType === 'AMBASSADOR' || isAmbOfferInCart ? (
        <Container>
          <span data-qa="totalPVText">PV Total</span>
          <span data-qa="totalPV">{totalPV}</span>
        </Container>
      ) : null}
    </Wrapper>
  )
}

export default OrderDetails
